export default {
  SUCCESS: 0 /* 성공 */,
  INVALID: 1 /* 값에 이상있음 */,
  ERROR: 2 /* 오류 발생 */,
  EXISTS: 3 /* 존재하거나 존재하지 않음 */,
  COMPANY: {
    EXISTS: 4 /* 회사가 존재하지 않음 */,
    EXPIRED: 5 /* 회사가 만료되었음. */,
    DISABLED: 7 /* 관리자에 의해 비활성화 */
  },
  ACCOUNT: {
    EXISTS: 6 /* 계정이 존재하지 않음. */,
    DISABLED: 10 /* 계정이 정지됨 */,
    REQUIRED_LOGIN: 13,
    EXPIRED: 14
  },
  PERMISSION: 8 /* 권한 없음 */,
  ADMIN: {
    EXISTS: 9,
    REQUIRED_LOGIN: 12
  },
  LOW_BALANCE: 11,
  NOT_ALLOW_TIME: 14,
  UNCLE: {
    EXISTS: 15,
    REQUIRED_LOGIN: 16
  },
  MASTER: {
    EXISTS: 17,
    REQUIRED_LOGIN: 18
  }
};
